import { useState } from 'react'
import { Loader2, Send } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'

interface Props {
  busy: boolean
  onSubmit: (text: string) => void | Promise<void>
}

export function AssistantComposer({ busy, onSubmit }: Props) {
  const [value, setValue] = useState('')

  const submit = async () => {
    const text = value.trim()
    if (!text || busy) return
    setValue('')
    await onSubmit(text)
  }

  return (
    <div className="flex gap-2 items-end">
      <Textarea
        value={value}
        placeholder="درخواستتان را بنویسید… (Ctrl + Enter برای ارسال)"
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) submit()
        }}
        disabled={busy}
        className="resize-none min-h-10 max-h-32 text-sm"
        dir="rtl"
      />
      <Button onClick={submit} disabled={busy || !value.trim()} size="icon" className="self-end h-9 w-9">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
      </Button>
    </div>
  )
}
